import { Action } from "../actions/actionsShared"
import {
  FETCH_APPROVED_DEVICE_VERSIONS_PREFIX,
  FETCH_USER_OTA_MESSAGES_PREFIX,
} from "../actions/otaActions"

const initialState = {
  messages: [],
  deviceVersions: [],
  loadingMessages: false,
}

const otaMessageReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${FETCH_USER_OTA_MESSAGES_PREFIX}${Action.BEGIN_SUFFIX}`:
      return {
        ...state,
        loadingMessages: true,
        result: "BEGINNING",
      }
    case `${FETCH_USER_OTA_MESSAGES_PREFIX}${Action.SUCCESS_SUFFIX}`:
      return {
        ...state,
        messages: action.payload.data.data.message,
        loadingMessages: false,
        result: "SUCCESS",
      }
    case `${FETCH_USER_OTA_MESSAGES_PREFIX}${Action.FAILURE_SUFFIX}`:
      return {
        ...state,
        loadingMessages: false,
        result: "FAILURE",
      }
    case `${FETCH_APPROVED_DEVICE_VERSIONS_PREFIX}${Action.BEGIN_SUFFIX}`:
      return {
        ...state,
        result: "BEGINNING",
      }
    case `${FETCH_APPROVED_DEVICE_VERSIONS_PREFIX}${Action.SUCCESS_SUFFIX}`:
      return {
        ...state,
        deviceVersions: action.payload.data.data.message,
        result: "SUCCESS",
      }
    case `${FETCH_APPROVED_DEVICE_VERSIONS_PREFIX}${Action.FAILURE_SUFFIX}`:
      return {
        ...state,
        result: "FAILURE",
      }
    default:
      return state
  }
}

export default otaMessageReducer
